import React from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  Container,
  Title,
  ContainerButtons,
  YesButton,
  NoButton,
} from './styles';
import { deleteAttachment } from './graphql';

const ModalDelete = (props) => {
  const {
    open,
    onClose,
    id,
    refetch,
  } = props;

  const handleDeleteClick = async () => {
    await deleteAttachment(id);
    refetch();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Container>
        <Title>Do you want to delete this attachment?</Title>
        <ContainerButtons>
          <YesButton onClick={onClose}>Cancel</YesButton>
          <NoButton onClick={handleDeleteClick}>Yes</NoButton>
        </ContainerButtons>
      </Container>
    </Modal>
  );
};

ModalDelete.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  id: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};

ModalDelete.defaultProps = {
  open: false,
};

export default ModalDelete;
